<template>
  <div class="report-header flex-between box-shadow-2">
    <div class="title">爱心小叮当情绪报告</div>
    <div class="right-area">
      <a-icon type="calendar" style="font-size: 16px" />
      <span class="date-text">{{ dateRangeText }}</span>
      <a-month-picker
        :value="currMonth"
        placeholder="选择年份月份"
        style="margin: 0 20px"
        :disabled="true"
        @change="changeMonthPicker"
      />
      <a-button
        v-has="'exportReport:show'"
        :loading="exportPdfLoading || exportLoading"
        class="export-btn"
        @click="exportReport"
      >
        导出报告
      </a-button>
    </div>
  </div>
</template>

<script>
import {
  getMonthStartAndEnd,
  getYearMonthByNum,
  formatYearMonth,
  isYearMonthLater,
  formatYearMonthDate,
} from '@/utils/date'
import moment from 'moment'
import { exportMonthReportWord } from '@/api/monthReport'

export default {
  name: 'ReportHeader',
  props: {
    schoolName: {
      type: String,
      default: '',
    },
    exportPdfLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dateRangeText: '',
      monthText: '',
      currMonth: '',
      exportLoading: false,
    }
  },
  computed: {
    monthReportTitle() {
      const baseTitle = `${formatYearMonth(this.currMonth, 'YYYY年MM月')}情绪报告`
      return this.schoolName ? `${this.schoolName}-${baseTitle}` : baseTitle
    },
  },
  created() {
    // 默认选择上一个月，且选择器禁用不可更改
    this.changeMonthPicker(getYearMonthByNum(-1))
  },
  methods: {
    changeMonthPicker(month) {
      if (isYearMonthLater(month)) {
        this.$message.warn('本月及本月之后的月报暂未生成')
        return
      }
      // 本月及本月之后，不做任何操作
      this.currMonth = formatYearMonth(month)
      const dateObj = getMonthStartAndEnd(this.currMonth)
      this.dateRangeText = `${formatYearMonthDate(
        dateObj.beginDate,
        'YYYY年MM月DD日'
      )} - ${formatYearMonthDate(dateObj.endDate, 'YYYY年MM月DD日')}`
      this.$emit('changeMonth', {
        beginDate: dateObj.beginDate,
        endDate: dateObj.endDate,
        currMonthInfo: {
          year: this.currMonth.split('-')[0],
          month: this.currMonth.split('-')[1],
        },
      })
    },
    // 导出月报 Word
    async exportReport() {
      if (this.exportLoading) return
      this.exportLoading = true
      try {
        const { beginDate, endDate } = getMonthStartAndEnd(this.currMonth)
        const data = await exportMonthReportWord({ startTime: beginDate, endTime: endDate })
        if (!data || data.size === 0) {
          this.$message.warning('文件下载失败')
          return
        }
        // 接口返回 docx 文件流，转成本地 blob 下载
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        })
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(blob, `${this.monthReportTitle}.docx`)
        } else {
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', `${this.monthReportTitle}.docx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }
      } catch (error) {
        this.$message.warning('导出失败，请稍后重试')
      } finally {
        this.exportLoading = false
      }
    },
  },
}
</script>

<style scoped lang="less">
.report-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  box-sizing: border-box;
  height: 94px;
  padding: 0 30px;
  background-color: #fff;
  .title {
    font-size: 26px;
    font-weight: 600;
    color: #333;
  }
  .right-area {
    .date-text {
      margin-left: 6px;
      color: #999999;
    }
    .month {
      margin: 0 20px;
      /deep/ .ant-select-selection {
        display: flex !important;
        align-items: center !important;
        width: 120px !important;
        height: 40px !important;
        border-radius: 27px !important;
      }
    }
    .export-btn {
      width: 120px;
      height: 40px;
      color: #fff;
      border-radius: 27px;
      background: linear-gradient(270deg, rgba(126, 200, 255, 1) 0%, rgba(76, 157, 253, 1) 100%);
    }
  }
}
</style>
